// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".selectedImage[data-v-0a109c4a] .avatar-background{border:4px solid #2c5bc5}.photo-selector-panel .scroll[data-v-0a109c4a]{scroll-snap-type:both proximity;overflow-x:auto;overflow-y:hidden}@media(min-width:992px){.photo-selector-panel .scroll[data-v-0a109c4a]::-webkit-scrollbar{background-color:#f0f0f0;height:.75rem!important}.photo-selector-panel .scroll[data-v-0a109c4a]::-webkit-scrollbar-thumb{background-color:#2c5bc5;border-radius:10px}}", ""]);
// Exports
module.exports = exports;
